import { useEffect, useState } from 'react'
import Stories from 'react-insta-stories'
import { generateCloudflareImageUrl } from 'services/cloudflare'

export default function ReactInstaStories({ data, currentIndex = 0 }) {
  const [show, setShow] = useState(false)
  const [stories, setStories] = useState([])

  useEffect(() => {
    setShow(false)
    if (data !== undefined && data.length > 0) {
      let stories_data = []
      for (let i = 0; i < data.length; i++) {
        stories_data.push({
          url: generateCloudflareImageUrl(data[i].url),
          duration: data[i].duration,
          header: {}
        })
      }
      setStories(stories_data)
      setTimeout(() => {
        setShow(true)
      }, 500)
    }
  }, [data])

  return( <>
    { show ? 
    <Stories
      stories={stories}
      defaultInterval={10000}
      width={432}
      height={768}
      loop={true}
      currentIndex={currentIndex}
    />
    : null }
  </> )
}